var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticClass:"p1_bgnotice p1_dialognotice",attrs:{"overlay":true,"overlay-class":"p1_noticeOverlay","close-on-click-overlay":false,"value":_vm.popnotice},on:{"click":_vm.clickNotice,"click-overlay":_vm.clickNotice}},[_c('div',{staticClass:"p1_textmsg"},[_vm._v(_vm._s(_vm.errMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }